import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q9 = [];

var entryPoint = [0, 0];

var selectedCount_Q9 = 0;

var routeMapSet_Q9 = 1;

var newPointDistanceQ9 = 0;

var plantArrayQ9 = [[], [], [], [], [], [], [], [], [], []];

var plantLeftArrayQ9 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q9 = new Phaser.Geom.Point(434, -200);

var array1_Q9 = [];

var leftQ9_p1 = new Phaser.Geom.Point(319, 233);
var leftQ9_p2 = new Phaser.Geom.Point(200, 437);
var leftQ9_p3 = new Phaser.Geom.Point(319, 395);
var leftQ9_p4 = new Phaser.Geom.Point(440, 437);

// var leftQ9_p6 = new Phaser.Geom.Point(40, 203);
// var leftQ9_p7 = new Phaser.Geom.Point(40, 326);
// var leftQ9_p8 = new Phaser.Geom.Point(120, 326);
// var leftQ9_p9 = new Phaser.Geom.Point(200, 326);

var leftExitWay_Q9 = new Phaser.Geom.Point(200, 900);

var leftFinalRouteMap_Q9 = [leftEntrance_Q9, leftQ9_p1, leftQ9_p2, leftQ9_p3, leftQ9_p4, leftExitWay_Q9];

var leftRouteMapSet_Q9 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q9 = new Phaser.Geom.Point(0, 0);

var exitWay_Q9 = new Phaser.Geom.Point(0, 0);

var Q9_p1 = new Phaser.Geom.Point(953, 186);
var Q9_p2 = new Phaser.Geom.Point(879, 317);
var Q9_p3 = new Phaser.Geom.Point(953, 291);
var Q9_p4 = new Phaser.Geom.Point(1034, 317);
var Q9_p5 = new Phaser.Geom.Point(802, 449);
var Q9_p6 = new Phaser.Geom.Point(879, 425);
var Q9_p7 = new Phaser.Geom.Point(953, 449);
var Q9_p8 = new Phaser.Geom.Point(1034, 425);
var Q9_p9 = new Phaser.Geom.Point(1112, 449);

export default class GameSceneQ9 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ9",
    });
  }

  preload() {
    this.load.image("BGQ9", "assets/Q9/BGQ9.png");

    this.load.image("D_BGQ9", "assets/Q9/D_BGQ9.png");
    this.load.image("L_curbQ9", "assets/Q9/L_curbQ9.png");

    this.load.image("hitBoxQ9", "assets/Q9/hitBoxQ9.png");
    this.load.image("curbQ9", "assets/Q9/curbQ9.png");
    this.load.image("rightPlotQ9", "assets/Q9/rightPlotQ9.png");
    this.load.image("whiteBoxQ9", "assets/Q9/whiteBoxQ9.png");

    this.load.image("leftGreyBoxQ9", "assets/Q9/leftGreyBoxQ9.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    this.BGQ9 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ9");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(0.2, 0.2).setVisible(false).setDepth(6);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);

    this.scoreRefresh();

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ9 = this.add.sprite(691, 67, "L_curbQ9").setOrigin(0).setDepth(2);
    this.add.sprite(687, 101, "rightPlotQ9").setOrigin(0).setDepth(2);

    this.hitBoxQ9_1 = this.add.sprite(876, 99, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);

    this.hitBoxQ9_2 = this.add.sprite(799, 235, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);
    this.hitBoxQ9_3 = this.add.sprite(876.5, 235, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(true).setDepth(2);
    this.hitBoxQ9_4 = this.add.sprite(953, 235, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);

    this.hitBoxQ9_5 = this.add.sprite(721, 369, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);
    this.hitBoxQ9_6 = this.add.sprite(799, 369, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(true).setDepth(2);
    this.hitBoxQ9_7 = this.add.sprite(876, 369, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);
    this.hitBoxQ9_8 = this.add.sprite(954, 369, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(true).setDepth(2);
    this.hitBoxQ9_9 = this.add.sprite(1031, 369, "hitBoxQ9").setInteractive({ cursor: "pointer", pixelPerfect: true }).setOrigin(0).setAlpha(0.1).setFlipY(false).setDepth(2);

    this.whiteBoxQ9_1 = this.add.sprite(876, 99, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);

    this.whiteBoxQ9_2 = this.add.sprite(799, 235, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);
    this.whiteBoxQ9_3 = this.add.sprite(876.5, 235, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(true).setDepth(2);
    this.whiteBoxQ9_4 = this.add.sprite(953, 235, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);

    this.whiteBoxQ9_5 = this.add.sprite(721, 369, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);
    this.whiteBoxQ9_6 = this.add.sprite(799, 369, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(true).setDepth(2);
    this.whiteBoxQ9_7 = this.add.sprite(876, 369, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);
    this.whiteBoxQ9_8 = this.add.sprite(954, 369, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(true).setDepth(2);
    this.whiteBoxQ9_9 = this.add.sprite(1031, 369, "whiteBoxQ9").setOrigin(0).setVisible(false).setFlipY(false).setDepth(2);

    ///

    this.leftGreyBoxQ9 = this.add.sprite(86, 104, "leftGreyBoxQ9").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    // this.Q9_ans = this.add.sprite(654.14,474.2, "qnBoard").setOrigin(0);

    this.Q9_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q9_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q9_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q9_leftDr = this.add.text(78, 578, "4", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q9_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q9_rightDr = this.add.text(715, 578, "9", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.8, 0.9).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    this.anims.create({
      key: "floweringQ9",
      frames: this.anims.generateFrameNames("flowering2Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "Flower",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    this.waterPlantOnLeftQ9();

    // var graphics = this.add.graphics();

    // graphics.fillStyle(0xff0000, 1);

    // graphics.fillCircle(Q9_p1.x, Q9_p1.y, 4);
    // graphics.fillCircle(Q9_p2.x, Q9_p2.y, 4);
    // graphics.fillCircle(Q9_p3.x, Q9_p3.y, 4);
    // graphics.fillCircle(Q9_p4.x, Q9_p4.y, 4);
    // graphics.fillCircle(Q9_p5.x, Q9_p5.y, 4);
    // graphics.fillCircle(Q9_p6.x, Q9_p6.y, 4);
    // graphics.fillCircle(Q9_p7.x, Q9_p7.y, 4);
    // graphics.fillCircle(Q9_p8.x, Q9_p8.y, 4);
    // graphics.fillCircle(Q9_p9.x, Q9_p9.y, 4);
  }

  waterPlantOnLeftQ9() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ9.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q9[0].x, leftFinalRouteMap_Q9[0].y, leftFinalRouteMap_Q9[1].x, leftFinalRouteMap_Q9[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ9() {
    //>//>>>hidden_console.log("startQ9");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q9 += 1;

      this.Q9_input.setText(selectedCount_Q9);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(array1_Q9, this.getPointFromCode(xcode, ycode));

      selectedCount_Q9 -= 1;
      this.Q9_input.setText(selectedCount_Q9);
    }
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q9[leftRouteMapSet_Q9-1],leftRouteMapSet_Q9-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q9[leftRouteMapSet_Q9 - 1], leftRouteMapSet_Q9 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (leftRouteMapSet_Q9 < leftFinalRouteMap_Q9.length - 1) {
          this.Q9_leftNr.setText(leftRouteMapSet_Q9);

          this.moveCanInitial(leftFinalRouteMap_Q9[leftRouteMapSet_Q9].x, leftFinalRouteMap_Q9[leftRouteMapSet_Q9].y, leftFinalRouteMap_Q9[leftRouteMapSet_Q9 + 1].x, leftFinalRouteMap_Q9[leftRouteMapSet_Q9 + 1].y);

          leftRouteMapSet_Q9 = leftRouteMapSet_Q9 + 1;
          // //>//>>>hidden_console.log(leftRouteMapSet_Q9);
        } else {
          this.Q9_leftNr.setVisible(true);
          this.Q9_input.setVisible(true);

          this.startQuestionQ9();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ9.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ9[k5].length; l5++) {
        plantLeftArrayQ9[k5][l5].setTexture("flowering2Anim").play("floweringQ9");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ9[1][1].setTexture("flowering2Anim").play("floweringQ9");

    for (var k = 0; k < plantArrayQ9.length; k++) {
      for (var l = 0; l < plantArrayQ9[k].length; l++) {
        plantArrayQ9[k][l].setTexture("flowering2Anim").play("floweringQ9");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ9");
    //   this.scene.start('GameSceneQ10');

    // },[],this);

    this.changeScene();
  }

  pathFinding() {
    finalRouteMap_Q9.push(array1_Q9[0]);

    array1_Q9.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Q9)

    for (let i = 0; i < finalRouteMap_Q9.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Q9.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap_Q9[i][0] - array1_Q9[j][0], 2) + Math.pow(finalRouteMap_Q9[i][1] - array1_Q9[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q9[i], array1_Q9[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap_Q9.push(array1_Q9[index]);
      array1_Q9.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap_Q9);

      if (finalRouteMap_Q9.length == 9) {
        break;
      }
    }
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();
            attempts = 0;

            this.wipeSceneQ9();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ9");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ9");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ9");
              this.scene.start("GameSceneQ10");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        if (gameState.attempted == 10) {
          gameState.gameWin = false;
          // this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
      },
      [],
      this
    );
  }

  wipeSceneQ9() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q9 = [];

    entryPoint = [0, 0];

    selectedCount_Q9 = 0;

    routeMapSet_Q9 = 1;

    newPointDistanceQ9 = 0;

    plantArrayQ9 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ9 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q9 = [leftEntrance_Q9,leftQ9_p1,leftExitWay_Q9];
    leftRouteMapSet_Q9 = 1;

    entrance_Q9.setTo(0, 0);

    exitWay_Q9.setTo(0, 0);

    array1_Q9 = [];
  }

  updateRouteMap(xcode, ycode) {
    array1_Q9.push(this.getPointFromCode(xcode, ycode));

    // //>//>>>hidden_console.log(finalRouteMap_Q9);
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q9_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q9_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q9_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q9_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q9_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q9_p6;
    } else if (xcode == 0 && ycode == 3) {
      return Q9_p7;
    } else if (xcode == 1 && ycode == 3) {
      return Q9_p8;
    } else if (xcode == 0 && ycode == 4) {
      return Q9_p9;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      if (selectedCount_Q9 == 9) {
        this.pathFinding();

        //>2

        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q9_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q9[0] == Q9_p1) {
          entrance_Q9.setTo(727, -200);
        } else if (finalRouteMap_Q9[0] == Q9_p2) {
          entrance_Q9.setTo(844, -200);
        } else if (finalRouteMap_Q9[0] == Q9_p3) {
          entrance_Q9.setTo(961, -200);
        } else if (finalRouteMap_Q9[0] == Q9_p4) {
          entrance_Q9.setTo(2078, 203);
        } else if (finalRouteMap_Q9[0] == Q9_p5) {
          entrance_Q9.setTo(727, 900);
        } else if (finalRouteMap_Q9[0] == Q9_p6) {
          entrance_Q9.setTo(844, 900);
        } else if (finalRouteMap_Q9[0] == Q9_p7) {
          entrance_Q9.setTo(961, 900);
        } else if (finalRouteMap_Q9[0] == Q9_p8) {
          entrance_Q9.setTo(2078, 326);
        } else if (finalRouteMap_Q9[0] == Q9_p9) {
          entrance_Q9.setTo(961, 900);
        }

        finalRouteMap_Q9.unshift(entrance_Q9);

        if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p1) {
          exitWay_Q9.setTo(727, -200);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p2) {
          exitWay_Q9.setTo(844, -200);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p3) {
          exitWay_Q9.setTo(961, -200);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p4) {
          exitWay_Q9.setTo(2078, 203);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p5) {
          exitWay_Q9.setTo(727, 900);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p6) {
          exitWay_Q9.setTo(844, 900);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p7) {
          exitWay_Q9.setTo(961, 900);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p8) {
          exitWay_Q9.setTo(2078, 326);
        } else if (finalRouteMap_Q9[finalRouteMap_Q9.length - 1] == Q9_p9) {
          exitWay_Q9.setTo(961, 900);
        }

        finalRouteMap_Q9.push(exitWay_Q9);

        this.moveCan(finalRouteMap_Q9[0].x, finalRouteMap_Q9[0].y, finalRouteMap_Q9[1].x, finalRouteMap_Q9[1].y);
      } else {
        //>3

        config.audio.wrongAnswer.play();

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        // this.Q9_ans.setTint(0xFFC2A2);

        this.Q9_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q9_rightDr.setFill("#C22300");
        this.Q9_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q9_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q9_rightDr.setFill("#2b2b2b");
            this.Q9_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }

  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q9[routeMapSet_Q9 - 1], routeMapSet_Q9 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q9 < finalRouteMap_Q9.length - 1) {
          this.moveCan(finalRouteMap_Q9[routeMapSet_Q9].x, finalRouteMap_Q9[routeMapSet_Q9].y, finalRouteMap_Q9[routeMapSet_Q9 + 1].x, finalRouteMap_Q9[routeMapSet_Q9 + 1].y);

          routeMapSet_Q9 = routeMapSet_Q9 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q9);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });
          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }
  showDeselect() {
    if (selectedCount_Q9 >= 9) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(array1_Q9[0].x, array1_Q9[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  hitboxClickAndHoverHandle() {
    this.BGQ9.setTexture("BGQ9");
    this.curbQ9.setTexture("curbQ9");
    this.hitBoxQ9_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_1, 0, 0);
      },
      this
    );
    this.hitBoxQ9_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_2, 1, 0);
      },
      this
    );
    this.hitBoxQ9_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_3, 0, 1);
      },
      this
    );
    this.hitBoxQ9_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_4, 1, 1);
      },
      this
    );
    this.hitBoxQ9_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_5, 0, 2);
      },
      this
    );
    this.hitBoxQ9_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_6, 1, 2);
      },
      this
    );
    this.hitBoxQ9_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_7, 0, 3);
      },
      this
    );
    this.hitBoxQ9_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_8, 1, 3);
      },
      this
    );
    this.hitBoxQ9_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ9_9, 0, 4);
      },
      this
    );

    this.hitBoxQ9_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(1);
      },
      this
    );
    this.hitBoxQ9_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(2);
      },
      this
    );
    this.hitBoxQ9_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(3);
      },
      this
    );
    this.hitBoxQ9_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(4);
      },
      this
    );
    this.hitBoxQ9_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(5);
      },
      this
    );
    this.hitBoxQ9_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(6);
      },
      this
    );
    this.hitBoxQ9_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(7);
      },
      this
    );
    this.hitBoxQ9_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(8);
      },
      this
    );
    this.hitBoxQ9_9.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ9(9);
      },
      this
    );

    this.hitBoxQ9_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
    this.hitBoxQ9_9.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ9();
      },
      this
    );
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  enableClicking() {
    this.hitBoxQ9_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_8.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ9_9.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ9_1.removeInteractive();
    this.hitBoxQ9_2.removeInteractive();
    this.hitBoxQ9_3.removeInteractive();
    this.hitBoxQ9_4.removeInteractive();
    this.hitBoxQ9_5.removeInteractive();
    this.hitBoxQ9_6.removeInteractive();
    this.hitBoxQ9_7.removeInteractive();
    this.hitBoxQ9_8.removeInteractive();
    this.hitBoxQ9_9.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }
    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ9(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ9();
    if (position == 1) {
      this.whiteBoxQ9_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ9_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ9_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ9_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ9_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ9_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ9_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ9_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBoxQ9_9.setVisible(true);
    }
  }

  removeWhiteBoxQ9() {
    this.whiteBoxQ9_1.setVisible(false);
    this.whiteBoxQ9_2.setVisible(false);
    this.whiteBoxQ9_3.setVisible(false);
    this.whiteBoxQ9_4.setVisible(false);
    this.whiteBoxQ9_5.setVisible(false);
    this.whiteBoxQ9_6.setVisible(false);
    this.whiteBoxQ9_7.setVisible(false);
    this.whiteBoxQ9_8.setVisible(false);
    this.whiteBoxQ9_9.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    plantArrayQ9[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y + 0, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ9[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y + 0, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArrayQ9[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y + 0, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ9[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 0, selectedPoint.y + 0, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    // plantArrayQ9[plantSelectionCode][4] = this.add.sprite(selectedPoint.x + 115,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantArrayQ9[plantSelectionCode][5] = this.add.sprite(selectedPoint.x + 160,selectedPoint.y,"playSwayAnim").setScale(0.3).play("plantbudding");

    // plantArrayQ9[plantSelectionCode][6] = this.add.sprite(selectedPoint.x + 145,selectedPoint.y + 30,"playSwayAnim").setScale(0.3).play("plantbudding");
    // plantArrayQ9[plantSelectionCode][7] = this.add.sprite(selectedPoint.x + 190,selectedPoint.y + 30,"playSwayAnim").setScale(0.3).play("plantbudding");
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    //>//>>>hidden_console.log(plantSelectionCode);

    if (plantSelectionCode == 3) {
      plantLeftArrayQ9[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 0, selectedPoint.y + 40, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else {
      plantLeftArrayQ9[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 70, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 50, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ9[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 0, selectedPoint.y - 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    }
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q9 <= selectedCount_Q9 || leftRouteMapSet_Q9 < leftFinalRouteMap_Q9.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");
            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
